import React from 'react';
import MaterialDialog from '@mui/material/Dialog';

import Transition from '../Transition';
import {
  DEFAULT_BACKDROP_PROPS,
  DEFAULT_TRANSITION_DURATION,
  DEFAULT_TRANSITION_PROPS,
} from './consts';
import type { DialogProps } from './types';

const Dialog = (props: DialogProps) => {
  const { TransitionProps, ...restProps } = props;

  return (
    <MaterialDialog
      BackdropProps={DEFAULT_BACKDROP_PROPS}
      TransitionComponent={Transition as any}
      TransitionProps={{ ...DEFAULT_TRANSITION_PROPS, ...TransitionProps }}
      transitionDuration={DEFAULT_TRANSITION_DURATION}
      {...restProps}
    />
  );
};

export default Dialog;
